module.exports = {
  language:{
    name:'English'
  },
  // 公共部分
  search:'查询',
  resetSearch:'重置搜索',
  serialNo:'序号',
  equipmentName:'设备名称',
  equipmentNo:'设备编号',
  operation:'操作',
  cancel:'取 消',
  confirm:'确 认',
  startDate:'开始日期',
  endDate:'结束日期',
  to:'至',
  amount:'金额',
  check:'查看',
  edit:'编辑',
  delete:'删除',
  save:'保存',
  dtuNo:'DTU编号',
  refresh:'刷新',
  export:'导出',
  import:"导入",
  add:'新增',
  user:'用户',
  username:'用户名',
  bankname:'银行名称',
  bankparm:'银行参数',
  equipmentType:'设备类型',
  multiple:'倍数',
  key:'按键',
  keyNumber:'按键号',
  beverageName:'饮品名称',
  price:'价格',
  englishName:'英文名',
  selectRecipe:'选择配方',
  yuan:'元',
  operationSucceeded:'操作成功',
  cupTypeSerialNo:'杯型编号',
  cupTypePercentage:'杯型百分比',
  setAmount:'设置金额',
  paidInAmount:'实收金额',
  none:'暂无',
  nodata:'暂无数据',
  yes:'是',
  no:'否',
  noPicture:'暂无图片',
  selectedImage:'选中图片',
  notSelectedImage:'未选中图片',
  pleaseSelectTheEquipmentModel:'请选择设备型号',
  pleaseEnterTheContent:'请输入内容',
  beverageImage:'饮品图片',
  submit:'提 交',
  notSelected:'未选择',
  browse:'浏览',
  variableName:'变量名',
  upload:'上传',
  image:'图片',
  video:'视频',
  name:'名称',
  time:'时间',
  confirmModification:'确 认 修 改',
  noChoiceNow:'暂无选择',
  equipment:'设备',
  success:'成功',
  back:'返 回',
  ok:'确定',
  okSpace:'确 定',
  queryFailedStatusCode:'查询失败！状态码：',
  selectAll:'全选',
  issued:'下发',
  deleteSuccessfully:'删除成功',
  tips:'提示',
  updateDate:'更新时间',
  cancelInput:'取消输入',
  saveSuccessfully:'保存成功',
  configureSuccessfully:'配置成功',
  saveFailed:'保存失败',
  equipmentmanagement:{
    ExcelBatchModify:'Excel批量修改',
    salesChannel:'销售渠道',
    user:'用户',
    query:'查询',
    dtuNumber:'DTU编号',
    machineModel:'设备型号',
    runningStatus:'运行状态',
    totalNumberOfCups:'出杯总数',
    totalAmount:'合计金额',
    signal:'信号',
    signalIntensity:'信号强度',
    netWorkStatus:'网络状态',
    activationTime:'激活时间',
    flowRecord:'流量记录',
    online:'在线',
    offline:'离线',
    parameterConfiguration:'参数配置',
    copy:'复制',
    recipeAssignment:'配方分配',
    addEquipment:'新增设备',
    maximumNumberOfKeys:'最大按键数',
    editEquipmentInfo:'设备信息修改',
    simCardNo:'物联网卡号',
    noSalesChannel:'暂无销售渠道',
    selectByExistingGroup:'按已有分组选择',
    checkAssigned:'查看已分配',
    beverageName:'饮品名称',
    noPicture:'暂无图片',
    ingredientName:'原料名称',
    category:'品类',
    coffee:'咖啡',
    milkTea:'奶茶',
    soybeanMilk:'豆浆',
    juice:'果汁',
    cupType:'杯型',
    selectTheEquipmentToBeCopied:'选择需要复制的设备',
    checkSelectedEquipments:'查看已选设备',
    copyEquipmentParameters:'复制设备参数',
    copyKeyParameters:'复制按键参数',
    copyPictureLibrary:'复制图片库',
    copyPartOfParameters:'复制局部参数',
    selectRecipeLibraryToAssign:'选择要分配的配方库',
    confirmAssignment:'确 认 分 配',
    currentMachineModel:'当前机器型号',
    functionSetting:'功能设置',
    commonKeySetting:'普通按键设置',
    equipmentImageLibrarySettings:'设备图片库设置',
    equipmentVideoSetting:'设备视频设置',
    dataStatistics:'数据统计',
    ingredientsSelection:'原料选择',
    ingredientsSelectionOfBeanToCupCoffeeMachine:'现磨机原料选择',
    priceSetting:'价格设置',
    beverageCalibration:'饮料校准',
    selectTemplate:'选择模板',
    templateName:'模板名称',
    qualityInspectionSituation:'质检情况',
    unqualifiedReason:'未质检通过原因',
    qualified:'已质检通过',
    unqualified:'未质检通过',
    qualityInspection:'质检',
    clearTestData:'清除测试数据',
    userLevel:'用户层级',
    assignedEquipments:'已分配设备',
    assignment:'分配',
    emptyAssignment:'清空分配',
    assignEquipmentName:'已分配设备名称',
    faultCode:'故障码',
    faultInformation:'故障信息',
    pleaseSelectTheSalesChannel:'请选择销售渠道',
    manualPositioning:'手动定位',
    checkRecipe:'查看配方',
    equipmentParameterConfiguration:'设备参数配置',
    checkTheSelectedEquipment:'查看已选择设备',
    whetherToConfirmToDeleteTheEquipment:'是否确认删除设备',
    dispensingTime:'出杯时间',
    confirmEquipment:'确认该设备通过质检',
    confirmToPass:'确 认 通 过',
    noPass:'不 通 过',
    reasonForNoPass:'不通过原因',
    pleaseEnterTheReasonForNoPass:'请输入不通过原因',
    editEquipmentAssignment:'编辑设备分配',
    expandEquipmentAssignment:'展开设备分配',
    expandUserAssignment:'展开用户分配',
    androidVersion:'安卓版本',
    mainBoardVersion:'主板版本',
    createDate:'创建日期',
    equipmentParameter:'设备参数',
    latestSubmittedData:'最新上送数据',
    simCardNO:'SIM卡号',
    equipmentAddress:'设备地址',
    pass:'通过',
    salesDetail:'销售详情',
    faultList:'故障列表',
    logUpload:'日志上传',
    checkPaymentQRCode:'查看支付二维码',
    faultTime:'故障时间',
    endTime:'结束时间',
    fileList:'文件列表',
    paymentQRCode:'支付二维码',
    timeSelection:'时间选择',
    selectTime:'选择时间',
    currentValue:'当前值',
    loading:'加载中',
    open:'打开',
    close:'关闭',
    read:'读取',
    currentData:'当前数据',
    historicalData:'历史数据',
    totalSalesNumberOfCups:'总销售杯数',
    totalSalesAmount:'总销售金额',
    pleaseSelect:'请选择',
    equipmentDetail:'设备详情',
    equipmentLog:'设备日志',
    manuallySelectTheEquipmentLocation:'手动获取设备位置',
    dataReading:'数据读取中，请稍后',
    readingSuccessfully:'读取成功',
    failedToReadParameters:'读取参数失败！请重试',
    theParameterOrNodeIsAbnormal:'参数或节点存在异常',
    theInputValueIsIncorrect:'输入值不正确',
    dataSavingPleaseWait:'数据保存中，请稍后',
    cannotBeEmpty:'不能为空',
    pleaseEnterANumber:'请输入数字',
    theInputParameterNeedsToBeLessThanTheMaximumValue:'输入参数需要小于最大值',
    theInputParameterNeedsToBeGreaterThanTheMinimumValue:'输入参数需要大于最小值',
    editKeySettings:'编辑按键设置',
    thisOperationWillPermanentlyDeleteThisKey:'此操作将永久删除该按键，是否继续？',
    deletionCancelled:'已取消删除',
    incorrectParameterName:'参数名不正确',
    modifyTheKeyConfigurationSuccessfully:'修改按键配置成功！',
    pleaseCompleteTheConfigurationInformation:'请完善配置信息',
    keyNumberAlreadyExists:'按键号已存在！',
    newlyAddKeyParameterConfigurationSuccessfully:'新增按键参数配置成功！',
    theSizeOfTheUploadedImageCannotMoreThan2MB:'上传图片大小不能大于 2MB!',
    deleteImageSuccessfully:'删除图片成功！',
    tickAtLeastOneVideoToBeDeleted:'勾选至少一个需要删除的视频',
    powderCanister:'粉盒',
    noIngredientForThisEquipment:'该设备暂无原料',
    powderVolumeIncreased:'粉量增加',
    normal:'正常',
    muchStronger:'加浓',
    extraStrong:'特浓',
    fineAdjustmentOfCupVolume:'杯量微调',
    channelInformationSavedSuccessfully:'通道信息保存成功！',
    modifyPriceSuccessfully:'修改价格成功！',
    refreshSuccessfully:'刷新成功',
    commandIssuedSuccessfully:'下发指令成功',
    equipmentInformationAcquisitionAbnormal:'设备信息获取异常！',
    thisImageHasBeenSelected:'该图片已选择',
    imageLibrarySavedSuccessfully:'图片库保存成功！',
    imageLibrarySavedUnSuccessfully:'图片库保存失败！',
    equipmentInformationAcquisitionFailed:'设备信息获取失败！',
    pleaseSelectTheImageToBeDeleted:'请选择需要删除的图片',
    batchAssignmentTaskCreatedSuccessfully:'创建批量分配任务成功，请到"我的任务"查看',
    automaticPositioningAcquisitionFailed:'自动定位获取失败',
    theEquipmentHasNoLocationInformationTemporarily:'该设备暂无位置信息',
    automaticPositioning:'自动定位中...',
    noSalesChannelTemporarily:'暂无销售渠道',
    successfullyAddedEquipment:'新增设备成功！',
    pleaseCompleteTheEquipmentInformation:'请完善设备信息',
    pleaseSelectAtLeastOneRecipeLibrary:'请选择至少一个配方库',
    confirmToClearTheTestData:'确定要清空测试数据吗？',
    clearingSuccess:'清除成功！',
    clearingFailed:'清除失败！',
    failedToObtainUserInformation:'用户信息获取失败！',
    successfullyModifiedTheQualityInspectionInformation:'修改质检信息成功！',
    pleaseCompleteTheQualityInspectionInformation:'请完善质检信息',
    thisOperationWillEmptyAllEquipmentsOfThisUser:'此操作将清空该用户所有设备，是否继续？',
    theExportTaskHasBeenCreated:'导出任务已创建，请前往我的任务查看',
    selectedUser:'已选用户',
    passwordReset:'密码重置',
    selectLevel1User:'选择一级用户',
    pleaseReselectTheUser:'请重新选择用户',
    pleaseCompleteUserInformation:'请完善用户信息',
    modifyPasswordSuccessfully:'修改密码成功！',
    wrongOriginalPassword:'原密码错误！',
    newPasswordInconsistent:'新密码不一致！',
    pleaseSelectAnAccountFirst:'请先选择账号！',
    pleaseSelectTheEquipmentToBeCopied:'请选择需要复制的设备！',
    addEquipmentTypeSuccessfully:'新增设备类型成功！',
    editEquipmentSuccessfully:'修改设备成功',
    viewDeviceLog:'查看设备日志',
    inShipment:'出货中',
    transactionCompletion:'交易完成',
    statisticsOfKeyCupBeating:'按键打杯统计',
    totalCups:'总杯数',
    numberOfCups:'打杯数',
    failedToGetLog:'获取日志失败',
    failedToObtainDtuNumberPleaseRefreshAndTryAgain:'DTU编号获取失败，请刷新后重试',
    failedToObtainDeviceParametersPleaseRefreshAndTryAgain:'设备参数获取失败，请刷新后重试',
    successfullyDeletedLogFile:'删除日志文件成功',
    selectDeviceAndKeyParameters:'选择设备和按键参数',
    keyParameters:'按键参数',
    copySucceeded:'复制成功',
    copyFailed:'复制失败',
    failedToObtainKeyParameter:'按键参数获取失败',
    readFailure:'读取失败',
    successfullyModifiedTheKey:'按键修改成功',
    pleaseEnterEnglishName:'请输入英文名',
    excelBatchEdit:'Excel批量修改',
  },
  logginaccount:{
    bindwechatuser:'绑定运维用户',
    HFstate:'HF状态',
    wxapplet:'微信小程序配置',
    accountName:'账号名称',
    loginAccount:'登录账号',
    nickName:'昵称',
    permissionManagement:'权限管理',
    pleaseSelectAUser:'请选择用户',
    pleaseSelectAGroup:'请选择分组',
    mobilePhoneNumber:'手机号码',
    mailbox:'邮箱',
    status:'状态',
    notConfigured:'未配置',
    configured:'已配置',
    configuration:'配置',
    clear:'清除',
    basicInformation:'基本信息',
    userOfTheAccount:'账号所属用户',
    alipayAccountConfiguration:'支付宝账号配置',
    weChatPaymentAccountConfiguration:'微信支付账号配置',
    weChatAppSecret:'微信AppSecret',
    whetherToConfirmToDeleteThisUser:'是否确认删除该用户',
    createLoginAccount:'创建登录账号',
    editLoginAccount:'编辑登录账号',
    loginName:'登录名',
    pleaseEnterNickName:'请输入昵称',
    pleaseEnterLoginName:'请输入登录名',
    resetPassword:'重置密码',
    originalPassword:'原密码',
    newPassword:'新密码',
    confirmPassword:'确认密码',
    pleaseEnterPassword:'请输入密码',
    permissionConfiguration:'权限配置',
    userInformation:'用户信息',
    whetherToConfirmToClearPaymentCollectionConfigurationInformation:'是否确认清除收款配置信息',
    configurePaymentCollectionInformation:'配置收款信息',
    moneyconfiguration:'数币配置',
    configureMoneyPaymentCollectionInformation:'配置数币配置',
    merchantID:'商户ID',
    wechatPaymentCertificate:'微信支付证书',
    clickUpload:'点击上传',
    only500k:'只能上传证书文件，且不超过500kb',
    certificatePassword:'证书密码',
    paymentCollectionDetails:'收款详情',
    paymentCollectionInformationOfThisAccountIsNotConfigured:'该收款账户信息未配置！',
    pleaseCompleteThePaymentCollectionConfiguration:'请完善收款配置！',
    currently1FileIsLimitedToBeSelected:'当前限制选择1个文件，本次选择了',
    filesAreSelected:'个文件',
    total:'共计',
    others:'其它',
    weChatMerchants:'微信商户',
    allocationSucceeded:'分配成功',
  },
  stc:{
    addTemplate:'新增模板',
    addEquipmentType:'新增设备类型',
    templateName:'模板名称',
    remark:'备注',
    notConfigured:'未配置',
    configureTemplate:'配置模板',
    cupTypeParameterConfiguration:'杯型参数配置',
    channelParameterConfiguration:'通道参数配置',
    classification:'分类',
    androidWithRecipe:'安卓（带配方库）',
    androidWithoutRecipe:'安卓（不带配方库）',
    selectPage:'选择页面',
    clickSelect:'点击选择',
    selectedPage:'已选择的页面',
    selectTemplate:'选择模板',
    keySetting:'按键设置',
    ingredientName:'原料名称',
    fullAmountValue:'满量值',
    powderDispensingRate:'出粉速率',
    alarmValue:'报警值',
    salesChannel:'销售渠道',
    userLevel:'用户层级',
    user1Level:'一级用户',
    user2Level:'二级用户',
    user3Level:'三级用户',
    user4Level:'四级用户',
    user5Level:'五级用户',
    user6Level:'六级用户',
    user7Level:'七级用户',
    user8Level:'八级用户',
    selectLevel:'选择层级',
    selectedUserLevel:'已选用户层级',
    contactPhoneNumber:'联系电话',
    mailbox:'邮箱',
    editTemplate:'编辑模板',
    equipmentTypeName:'设备类型名称',
    equipmentTypeNo:'设备类型编号',
    pleaseSelectACategory:'请选择分类',
    pleaseEnterComments:'请输入备注',
    pleaseEnterEquipmentTypeNO:'请输入设备类型编号',
    pleaseEnterEquipmentTypeName:'请输入设备类型名称',
    editEquipmentType:'编辑设备类型',
    pleaseSelectTemplate:'请选择模板',
    newAddedParameter:'新增参数',
    theKeyHasBeenDeleted:'该按键已删除',
    modifyTheKeySetting:'修改按键设置',
    pleaseEnterTheValue:'请输入值',
    pleaseEnterTheVariableName:'请输入变量名',
    pleaseEnterMultiple:'请输入倍数',
    templateConfiguration:'模板配置',
    newAddedKeySetting:'新增按键设置',
    step1:'步骤 1',
    step2:'步骤 2',
    nextStep:'下一步',
    noIngredient:'暂无原料',
    newAddedConfiguration:'新增配置',
    selectIngredient:'选择原料',
    newAddedSalesChannel:'新增销售渠道',
    editSalesChannel:'编辑销售渠道',
    salesChannelName:'销售渠道名称',
    salesChannelNO:'销售渠道编号',
    autoGenerate:'自动生成',
    pleaseEnterUserName:'请输入用户名',
    pleaseEnterGroupName:'请输入用户组名',
    pleaseEnterContactPhoneNumber:'请输入联系电话',
    pleaseEnterTheEmailAddress:'请输入邮箱',
    pleaseEnterATemplateName:'请输入模板名称',
    pleaseEnterTheParameterName:'请输入参数名',
    selectAUser:'选择用户',
    confirmToRemove:'确定移除',
    addNewTemplateSuccessfully:'新增模板成功',
    addNewTemplateUnsuccessfully:'新增模板失败',
    thisOperationWillPermanentlyDeleteTheTemplate:'此操作将永久删除该模板，是否继续？',
    modifyTheEquipmentTypeSuccessfully:'修改设备类型成功！',
    pleaseCompleteTheChannelInformation:'请完善渠道信息',
    deleteTheEquipmentTypeSuccessfully:'删除设备类型成功！',
    addNewKeySuccessfully:'新增按键成功！',
    newlyAddKeyConfigurationSuccessfully:'新增按键设置成功！',
    newlyAddParameterConfigurationSuccessfully:'新增参数配置成功！',
    pleaseNewlyAddAtLeastOneParameter:'请至少新增一个参数！',
    failedToGetChannelData:'获取通道数据失败！',
    pleaseSelectAnIngredient:'请选择一个原料！',
    uploadSuccessfully:'上传成功',
    newlyAddSalesChannelSuccessfully:'新增销售渠道成功！',
    modifySalesChannelSuccessfully:'修改销售渠道成功！',
    deleteSalesChannelSuccessfully:'删除销售渠道成功！',
    thisOperationWillPermanentlyDeleteTheUser:'此操作将永久删除该用户，是否继续？',
    pleaseSelectLevel1User:'请选择一级用户',
    thereIsNoUserBoundToTheCurrentAccount:'当前账户没有绑定用户，请刷新重试！',
    newlyAddedUser:'新增用户',
    groupName:'用户组名称',
    editUser:'编辑用户',
    commodityAmount:'商品金额',
    refundSucceeded:'退款成功',
    theExportLimitIsLessThan1Million:'导出限制100万条以内，请重新查询！',
    channelNo:'通道序号',
    pleaseCompleteTheEquipmentTypeInformation:'请完善设备类型信息',
  },
  saledata:{
    outTradeNo:'第三方订单号',
    coldhotname:'饮品冷热分类',
    transactionMode:'交易方式',
    paymentMethod:'支付方式',
    systemOrderNumber:'系统订单号',
    orderStatus:'订单状态',
    orderNO:'订单号',
    contactType:'接触式',
    nonContactType:'非接触式',
    free:'免费',
    wechat:'微信',
    aliPay:'支付宝',
    commodityName:'商品名称',
    cupTypeName:'杯型名称',
    paymentTime:'支付时间',
    unPaid:'未支付',
    paid:'已支付',
    commodityDeliverySucceeded:'订单成功',
    commodityDeliveryFailed:'退款中',
    refunded:'已退款',
    refund:'退款',
    refundInProgress:'退款中',
    commodityRefund:'商品退款',
    refundAmount:'退款金额',
    confirmRefund:'确认退款',
    commodityDeliveryFailed2:'出货失败',
  },
  remotecontrol:{
    upgradeAndroidProgram:'升级安卓程序',
    upgradeMainBoardProgram:'升级主板程序',
    pleaseTickTheEquipmentFirst:'请先勾选设备',
    whetherLocked:'是否锁定',
    networkStatus:'网络状态',
    remoteRestart:'远程重启',
    lock:'锁定',
    unlock:'解锁',
    onlyApk:'只能上传apk文件',
    historyUploadRecord:'历史上传记录',
    upgradeNow:'立即升级',
    onlyBin:'只能上传bin/bin.TR文件',
    pleaseSelectTheSameEquipmentType:'请选择相同的设备类型',
    normal:'正常',
    locking:'锁定',
    online:'在线',
    offline:'离线',
    selectFile:'选取文件',
    operationUser:'操作用户',
    operationItem:'操作项目',
    modifyContent:'修改内容',
    operationIP:'操作IP',
    operationTime:'操作时间',
    mainBoardSoftwareVersion:'主板软件版本',
    failedToQueryFileList:'查询文件列表失败！状态码：',
    upgradeAndroidSuccessfully:'升级安卓成功！',
    upgradeMainBoardSoftwareSuccessfully:'升级主板软件成功！',
    theEquipmentDoesNotNeedToBeUnlocked:'该设备无需解锁！',
    theEquipmentDoesNotNeedToBeLocked:'该设备无需锁定！',
    pleaseWait:'请稍后......',
    equipmentRestartSucceeded:'设备重启成功',
    wash:'清洗搅拌',
    eDoorLock:'电子门锁',
    takeDoorLock:'取杯门锁',
    resetCup:'落杯机构复位',
  },
  CalibrationRecords:{
    executionDate:'执行开始时间',
    executionEndDate:'执行结束时间'
  },
  operatelog:{
    operationLog:'操作日志',
    userLogin:'用户登录',
    signIn:'登录',
    newEquipmentParameters:'新增设备参数',
    deleteCup:'删除杯型',
    recipeLibraryManagement:'配方库管理',
    deleteRawMaterials:'删除原料',
    uploadFiles:'上传文件',
    file:'文件',
    newRawMaterials:'新增原料',
    updateDrinks:'更新饮品',
    newCupSize:'新增杯型尺寸',
    updateCupSize:'更新杯型尺寸',
    newKeyConfiguration:'新增按键配置',
    updateAndroidPrograms:'更新安卓程序',
    updateTheMotherboardProgram:'更新主板程序',
    equipmentOperation:'设备操作',
    deleteDeviceParameters:'删除设备参数',
    newEquipment:'新增设备',
    bindingCupType:'绑定杯型',
    updateDevice:'更新设备',
    deleteDevice:'删除设备',
    bindingDevice:'绑定设备',
    newSalesChannel:'新增销售渠道',
    deleteFile:'删除文件',
    newDrinks:'新增饮品',
    newUser:'新增用户',
    deleteUser:'删除用户',
    updateRawMaterialData:'更新原料数据',
    clearUsersDevice:'清空用户的设备',
    deleteAccount:'删除账户',
    newAccount:'新增账户',
    newPermission:'新增权限',
    assignRecipeLibrary:'分配配方库',
    updateKeyInformation:'更新按键信息',
    updateEquipmentParameters:'更新设备参数',
    newConfigurationTemplate:'新增配置模板',
    updateUser:'更新用户',
    deleteKeyConfigurationTemplate:'删除按键配置模板',
    updateAccount:'更新账户',
    unbindingDevice:'解绑设备',
    deleteKeyConfiguration:'删除按键配置',
    deleteTask:'删除任务',
    newEquipmentType:'新增设备类型',
    deleteDeviceType:'删除设备类型',
    deleteCupSize:'删除杯型尺寸',
    clearAUsersCollectionAccount:'清除某个用户的收款账户',
    bindCollectionConfiguration:'为某个用户绑定收款配置',
    updateCollectionConfiguration:'更新收款配置',
    newMenu:'新增菜单',
    updateDeviceType:'更新设备类型',
    updateSalesChannel:'更新销售渠道',
    batchBindingCupType:'批量绑定杯型',
    batchEquipmentBindingCupType:'批量设备绑定杯型',
    deleteSalesChannel:'删除销售渠道',
    addCoupon:'新增优惠券',
    deleteCoupon:'删除优惠券',
    modifyCoupon:'修改优惠券',
    allocateEquipment:'分配设备',
    distributionChannel:'销售渠道',
    userManagement:'用户管理',
    loginAccount:'登录账号',
    permissionManagement:'权限管理',
    recipeLibraryAssignment:'配方库分配',
    remoteControl: '远程控制',
    task:'任务',
    standardDataConfiguration: '标准数据配置',
    collectionConfiguration: '收款配置',
    system:'系统',
    coupon:'优惠券',
    equipmentManagement:'设备管理',
  },
  trafficwarning:{
    iotCardNo:'物联网卡号',
    activationTime:'激活时间',
    usedFlow:'已用流量',
    remainingFlow:'剩余流量',
    platformBelongedTo:'所属平台',
    newPlatform:'新平台',
    oldPlatform:'老平台',
    operator:'运营商',
    refreshTime:'刷新时间',
    read:'读取',
    activateStartDate:'激活开始日期',
    activateEndDate:'激活结束日期',
    expirationTime:'到期时间',
    cardStatus:'卡状态',
    totalFlow:'全部流量',
    pleaseEnterTheIOTCardNumber:'请输入物联网卡号',
    newlyAddIOTCardSuccessfully:'新增物联网卡成功',
    pleaseCompleteCardNumberInformation:'请完善卡号信息',
    oneClickRead:"一键读取",
  },
  myduty:{
    taskName:'任务名称',
    status:'状态',
    failureReason:'失败原因',
    taskType:'任务类型',
    inProgress:'进行中',
    complete:'已完成',
    failure:'失败',
    startTime:'开始时间',
    completionTime:'完成时间',
    orderExport:'订单导出',
    equipmentFaultExport:'设备故障导出',
    batchEquipmentAllocationFormula:'批量设备分配配方',
    batchEquipment:'批量修改设备',
    unSuccessfulEntries:'不成功的条目',
  },
  home:{
    notice:'公告',
    setting:'设置',
    logOut:'退出登录',
    homePage:'首页',
    equipmentManagement:'设备管理',
    milkseriomanage:'奶茶系列管理',
    milkclass:'奶茶配方分类',
    milkteamachinemanagement:'奶茶机管理',
    teaCupManagement:'茶饮生产',
    milkteaCupManagement:'奶茶机生产',
    cupteamachinemanagement:'机台管理',
    formulaclass3S:'萃茶机3S配方管理',
    formulamanage:'萃茶机S配方管理',
    materialconfig:'物料配置',
    materialtype:'物料料仓',
    materialunit:'物料单位',
    specconfig:'规格配置',
    equipmentList:'设备列表',
    equipmentQualityInspection:'设备质检',
    assignEquipment:'分配设备',
    faultList:'故障列表',
    accountManagement:'账号管理',
    loginAccount:'登录账号',
    paymentConfiguration:'收款配置',
    beverageManagement:'饮品管理',
    nbbg2RecipeLibrary:'NBBG2配方库',
    newCombiRecipeLibrary:'E2S配方库',
    recipeLibraryAssignment:'配方库分配',
    standardDataConfiguration:'标准数据配置',
    equipmentTypeConfiguration:'设备类型配置',
    salesChannelConfiguration:'销售渠道配置',
    userLevelConfiguration:'用户层级配置',
    salesDataStatistics:'销售数据统计',
    remoteControl:'远程控制',
    flowEarlyWarning:'流量预警',
    myTask:'我的任务',
    userLogin:'用户登录',
    cloudPlatform:'云平台',
    forgotPassword:'忘记密码',
    rememberMe:'记住我',
    login:'登录',
    loginSuccessfully:'登录成功',
    applet:'小程序',
    appletmember:'小程序会员',
    coupon:'优惠券',
    Rechargestr:'充值策略',
    Newbenefits:'新人福利策略',
    Sginbenefits:'签到福利策略',
    washrecords:'清洗记录',
    calibrationRecords:'校准记录'
  },
  homepage:{
    salesData:'销售数据',
    salesTotalAmount:'销售总金额',
    salesTotalNumberOfCups:'销售总杯数',
    ranking:'排名',
    salesNumberOfCups:'销售杯数',
    todaySalesData:'年度销售数据',
    todaySalesAmount:'今日销售金额',
    todaySalesNumberOfCups:'今日销售杯数',
    cup:'杯',
    equipmentSalesChampion:'设备销冠',
    beverageSalesChampion:'饮料销冠',
    equipmentNormal:'设备正常',
    equipmentOffline:'设备离线',
    equipmentNotActive:'设备未激活',
    fault:'故障',
    beverageRanking:'饮料排行',
    alarmStatistics:'实时故障报警',
    bigDataBulletinBoard:'大数据看板',
    welcome:'欢迎您',
    dataLoading:'数据加载中',
    operationAndMaintenanceFailure:'运维故障',
    controlSystemFailure:'控制系统故障',
    waterCircuitUnitFailure:'水路单元故障',
    heatingCoolingFailure:'加热/制冷故障',
    feedingUnitFailure:'供料单元故障',
    others:'其他',
    huifuappconfiguration:'汇付应用配置',
    huifuuserconfiguration:'汇付用户配置',
    huifupayconfiguration:'汇付支付配置',
    todaybeverage:'今日打杯',
    equipdailydata:'设备每日数据',
    equiptotaldata:'设备总数据',
    salestoday:'当日销量',
    amounttoday:'当日金额',
    Currentlymalfunction:'目前发生故障',
    Currentlymalfunctionnow:'当前正在发生的故障',
    totalsales:'总销量',
    equipmentNo:'设备编号',
    openfullscreen:'打开全屏',
    closefullscreen:'关闭全屏',
  },
  surong:{
    beverageName:'饮品名称',
    pleaseSelectAGroup:"请选择分组",
    cupSizeEditing:'杯型尺寸编辑',
    category:'品类',
    coffee:'咖啡',
    milkTea:'奶茶',
    soybeanMilk:'豆浆',
    juice:'果汁',
    ingredientName:'原料名称',
    alarmExtensionValue:'报警延伸值',
    cupType:'杯型',
    nameDisplayedOnTheScreen:'屏幕显示名称',
    beverageType:'饮品种类',
    englishNameidisplayedOnTheScreen:'屏幕显示英文名',
    ingredientsSelection:'原料选择',
    clickSelect:'点击选择',
    cupTypeTemplate:'杯型模板',
    recipeGrouping:'配方分组',
    cupTypeParameter:'杯型参数',
    whetherUniversal:'是否通用',
    clickToSelectTheUser:'点击选择用户',
    total:'全部',
    pleaseEnterTheCupSizeName:'请输入杯型尺寸名称',
    beverageEnglishName:'饮品英文名',
    recipeInformation:'配方信息',
    basicInformation:'基础信息',
    pleaseEnterBeverageName:'请输入饮品名称',
    pleaseEnterBeverageEnglishName:'请输入饮品英文名',
    solublePowder1Select:'速溶粉1选择',
    solublePowder2Select:'速溶粉2选择',
    cupTypeInformation:'杯型信息',
    newAddedCupType:'新增杯型',
    selectAUser:'选择用户',
    pleaseEnterTheAlarmExtensionValue:'请输入报警延伸值',
    cupSizeName:'杯型尺寸名称',
    cupSizeEnglishName:'杯型英文名',
    pleaseSelectTheTypeOfDrink:'请选择饮品种类',
    pleaseEnterTheNameOfTheRawMaterial:'请输入原料名称',
    rawMaterialPicture:'原料图片',
    classification:'原料分类',
    pleaseEnterTheCupNumber:'请输入杯型编号',
    coffeeBeanSelection:'咖啡豆选择',
    liquidMilkSelection:'液体奶选择',
    pleaseSelectCupType:'请选择杯型',
    typeOfDrink:'饮品类型',
    selectRecipeLibrary:'选择配方库',
    grouping:'组合分组',
    selectedRecipes:'已选择的配方',
    standardsForInstantDissolvers:'速溶机标准',
    areYouSureToDeleteThisCupSize:'是否确认删除该杯型尺寸',
    succeededInModifyingTheCupSize:'修改杯型尺寸成功',
    nameCannotBeEmpty:'名称不能为空',
    pleaseEnterTheCupName:'请输入杯型名称',
    succeededInAddingCupType:'新增杯型成功',
    theDrinkInformationDoesNotExistPleaseRefreshAndTryAgain:'该饮品信息不存在，请刷新重试',
    pleaseCompleteTheDrinkInformation:'请完善饮品信息',
    pleaseCompleteTheCupTypeInformation:'请完善杯型信息',
    hotDrink:'热饮',
    coldDrink:'冷饮',
    pleaseSelectAType:'请选择类型',
    onSiteMillStandard:'现磨机标准',
    pleaseSelectCoffeeBeans:'请选择咖啡豆',
    pleaseSelectInstantPowder:'请选择速溶粉',
    pleaseSelectFreshMilk:'请选择鲜奶',
    listOfDrinkCups:'饮品杯型列表',
    coffeeBean:'咖啡豆',
    instantPowder:'速溶粉',
    liquidMilk:'液体奶',
    hot:'热',
    cold:'冷',
  },
  formulaclass: {
    bindstorage:'绑定料仓号',
    teatoseries:'茶饮分配到系列',
    TeaVol:'茶量',
    PressGear:'压饼档位',
    PressTime:'压饼时间',
    PressTemp:'温度',
    WaterVol:'水量',
    SoakTime:'浸泡时间',
    MilkPrice:'价格',
    inputformulaPrice:'请输入茶饮价格',
    batchassignment:'批量分配',
    createnewMilkcup:'新增奶茶',
    inputMaterialStore:'请输入料仓号(先选择奶茶系列)',
    MaterialStorevalue:'料仓号',
    BrewTeaTime:'泡茶时间',
    remake:'备注',
    SoakTeaTime:'浸泡时间',
    IceWaterTime:'冰水出水时间',
    HotWaterTime:'热水出水时间',
    PowderWeight:'出粉重量',
    PowderDelayTime:'出粉延时',
    PowderTrueTime:'出粉打开',
    PowderFalseTime:'出粉关闭',
    StirringRate:'搅拌速率',
    ExtraStirringTime:'额外搅拌',
    IceExWaterTime:'冰(额外出水)',
    IceExWaterDeTime:'冰(额外延时)',
    HotExWaterTime:'热(额外出水)',
    HotExWaterDeTime:'热(额外延时)',
    ActrualPowder:'实际出粉重量',
    inputcupmilkID:'奶茶编号',
    cupmilkID:'奶茶编号',
    MilkCupEditTitle:'奶茶配方修改',
    checkMilkCupAssigned:'查看已分配的奶茶配方',
    CopySuccess: '奶茶配方修改成功',
    inputserioname: '请输入系列名(必填)',
    MilkCupCopyTitle:'奶茶配方修改',
    MilkCupCopy:'修改',
    DeleteSuccess:'奶茶配方删除成功',
    AddSuccess: '奶茶配方添加成功',
    pleaseinputmaterial: '请先给该料仓设置原料',
    dtuformula: '设备编号',
    inputdtuformula: '请先键入设备编号(非必填)',
    SelectMilkCup: '系列设置奶茶',
    SelectMaterialStore: '请选择料仓和对应原料',
    materialstore: '料仓',
    inputmaterialstore: '请输入料仓参数(请先输入设备编号)',
    formulatype: '类型',
    formulabigcup: '大杯参数',
    HotDrink: '热饮',
    ColdDrink: '冷饮',
    inputformulacoldcup:'请输入冷饮参数',
    inputformulahotcup:'请输入热饮参数',
    formulacode: '编码',
    formulaname: '名称',
    formulastate: '状态(必填)',
    formulacreatetime: '更新时间',
    inputformulaname: '请输入奶茶名称(先选择奶茶料仓)',
    inputHotDrinkParm: '请输入热饮参数(先选择奶茶料仓)',
    inputColdDrinkParm: '请输入冷饮参数(先选择奶茶料仓)',
    pleaseinputmaterialnumber: '请输入物料量',
    HotMilkTemp: '热奶茶温度',
    ColdMilkTemp: '冷奶茶温度',
    MilkTempNumber: '奶茶温度数值',
    inputMilkHotTempNumber: '请输入热奶茶温度',
    inputMilkColdTempNumber: '请输入冷奶茶温度',
  },
  formulamanagement: {
    createnewcuptea: '新增茶饮',
    SerioId:'系列编号',
    equipSetSerio:'展开该机器系列',
    SerioSelectEquip: '请选择该系列对应设备',
    MilkCupID:'奶茶编号',
    pleaseCompleteTheFormulaInformation:'请把奶茶系列信息完善',
    UpdateSuccess:'奶茶系列更新成功',
    DeleteSuccess:'奶茶系列删除成功',
    AddSuccess:'奶茶系列添加成功',
    formulaEditTitle:'奶茶系列修改',
    formulaEdit: '修改',
    formulaDelete: '删除',
    cupserioname: '系列名称',
    cupserio:'状态',
    cuptype:'杯型' ,
    formulamanastate: '状态',
    createnewcup: '新增系列',
    serioname: '系列名称',
    inputformulamanacode: '请输入编码(必填)',
    inputserioname: '请输入系列名',
    inputcupserio: '请输入状态',
    formulacreatetime: '系列创建时间',
  },
    specconfig: {
        groupid: '分组编号',
        materialcode: '编号',
        inputmaterialcode: '请输入编号',
        materialname: '原料类型名称',
        inputmaterialname: '请输入原料类型名称',
        materialstate: '状态',
        materialcreatetime: '创建时间',
        MilkCupMaterialInfoType: '原料类型',
    },
    materialstorage: {
        materialstorageid: '料仓编号',
        DeleteSuccess:'料仓信息删除成功',
        AddSuccess:'料仓信息添加成功',
        pleaseCompleteTheMaterialInformation:'请选择原料',
        pleaseCompleteTheStorageInformation:'请完善料仓信息',
        BindSuceess:'状态修改成功',
        assignmaterial: '分配原料',
        ClearInput:'重置输入',
        MaterialStoreAddTitle: '添加料仓',
        inputmaterialstoragecode: '请输入料仓编码',
        inputmaterialstoragename: '请输入料仓名称',
        materialstoragecode: '料仓编码',
        DTUNumber: '设备编号',
        materialstoragename: '料仓名称',
        inputmaterialcode: '请输入编号',
        materialid: '原料编号',
        inputmaterialname: '请输入原料类型名称',
        materialstate: '状态',
        materialcreatetime: '创建时间',
    },
  materialconfig: {
    EquipId:"机器编号",
    Materialid:"原料编号",
    pleaseCompleteTheMaterialInformation: '请完善原料信息',
    AddMaterialSuccess: '添加原料信息成功',
    MaterialUpdateSuccess: '奶茶原料更新成功',
    MaterialEditTitle: '奶茶原料修改',
    MilkCupMaterialInfoCode: '原料编码',
    MilkCupMaterialInfoName: '原料名称',
    MilkCupMaterialInfoMargin: '原料余量',
    MilkCupMaterialInfoType: '原料类型',
    AddMaterialInfo: '添加原料信息',
    materialstate: '状态',
    materialcreatetime: '创建时间',
    wcname:'小程序用户名'
  },
  cupteamachinemanagement:{
    serial:'系列',
    MaterialAddSuccess:'奶茶原料分配成功',
    ConfirmEditSerioName:'确认修改系列名称',
    MaterialStoreAssign: '奶茶料仓分配',
    MaterialAssign: '奶茶原料分配',
    MilkTeaCopy: '茶饮复制',
    expMilkList: '已分配茶饮列表',
    MilkList: '茶饮列表',
    checkStoreAssigned: '查看料仓已分配',
    checkMaterialAssigned: '查看原料已分配',
    InputMilkSort:'请输入茶饮绑定序号',
    InputMilkSerioSort:'请输入茶饮系列绑定序号',
    KeySortMilk:'按键序号',
    EditSuccess:'修改成功',
    ConfirmDistribute:'确认下发',
    parameterconfig:'参数配置',
    storageconfig:'料仓配置',
    copyoneparameter:'复制个别参数',
    copyfunctionparameter:'复制功能参数',
    copykeyparameter:'复制按键参数',
    copyparameter:'复制参数',
    milkname:'奶茶名称',
    milkprice:'茶饮价格',
    milksort:'奶茶序号',
    ishotenabled:'热饮是否启用',
    iscoldenabled:'冷饮是否启用',
    editdrink:'修改饮品',
    Selection:'选择项',
    teadistribution:'茶饮分配',
    keyconfigsscreen1:'1号屏幕按键参数',
    keyconfigsscreen2:'2号屏幕按键参数',
    keyconfigsscreen3:'3号屏幕按键参数',
    seroBindQuantity:'系列下已绑定奶茶数量',
    Expandseries:'展开该系列',
    Confirmdistributetea:'确认分配茶饮',
    allocatedteadistribute:'已分配茶饮分配',
    milkteaid:'茶饮编号',
    milkteaname:'茶饮名称',
    serioSort:'系列序号',
    bindedquantity:'已绑定数量',
    Isenabled:'是否启用',
    AssignDrink:'分配饮品',
    expseriolist:'展开已分配系列',
    editserio:'修改该系列',
    milkteadetails:'奶茶详细信息',
    hotname:'热饮名称',
    coldname:'冷饮名称',
    hotparameter:'热饮参数信息',
    coldparameter:'冷饮参数信息',
    hotstorageno:'热茶饮料仓号',
    coldstorageno:'冷茶饮料仓号',
    serialstate:'系列状态',
    disable:'不启用',
    enable:'启用',
    recoveryamount:'恢复量',
    warningamount:'警戒量',
    cover:'补仓',
    copynewcup:'复制新茶饮',
    assignnewcup:'分配新茶饮',
    screen:'屏幕',
    copycup:'复制茶饮',
  },
  washrecords: {
    washproject: '项目',
    executiontime: '执行时间',
    calibrationvalue: '校准值',
    materialname: '原料类型名称',
    inputmaterialname: '请输入原料类型名称',
    materialstate: '状态',
    materialcreatetime: '创建时间',
    MilkCupMaterialInfoType: '原料类型',
  },
  promotions:{
      usestatus:'使用状态',
      addpromotions: '新增优惠券',
      expiredate: '有效截止日期：',
      calibrationvalue: '校准值',
      promotionsname: '优惠券名称',
      deductionprice: '抵扣价格（元）',
      couponsnumber: '优惠券数量',
      couponsnumberextra: '优惠券剩余数量',
      productcategory: '指定商品分类',
      promotionsnameadd: '优惠券名称*：',
      deductionpriceadd: '抵扣价格*：',
      couponsnumberadd: '优惠券数量*：',
      selecttime:'选择日期',
      distributecoupons:'派发优惠券',
      phonenumber:'用户手机号',
      distributenumber: '派发数量',
      distribute:'派发',
      details:'详情',
      accountname:'账号名称',
      distributetime: '派发时间',
      coupondetails:'优惠券派发详情'
  },
  NewEmployeeBenefits:{
      isnewcomercoupon: '新人是否发放优惠券',
      isnewcomerpoints: '新人是否发放积分',
      isnewcomerbalance: '新人是否发放余额',
      isoldcomercoupon: '老人是否发放优惠券',
      isoldcomerpoints: '老人是否发放积分',
      isoldcomerbalance: '老人是否发放余额',
      newcomercouponnumber:'新人券数量',
      newcomercoupons:'新人券',
      newcomerpoints:'新人积分数量',
      newbalancequantity:'新人余额数量',
      oldcomercouponnumber:'老人优惠券数量',
      oldcomerpoints:'老人积分数量',
      oldbalancequantity:'老人余额数量',
      createnow:'立即创建',
  },
  SignInBenefits:{
      signinrule:'签到规则配置',
      signinpointsday:'每日签到积分',
      signinbalanceday:'每日签到余额',
      signincouponsday:'每日签到优惠券',
      signincouponsnumberday:'每日签到优惠券数量',
      addedrewardsdays:'增值奖励触发天数',
      addedrewardsdayssigninpoints:'增值后每日签到积分',
      addedrewardsdayssigninbalance:'增值后每日签到余额',
      addedrewardsdayssignincoupons:'增值后每日签到优惠券',
      addedrewardsdayssignincouponsnumber:'增值后每日签到优惠券数量',
      accumulatedsigninreward:'累计签到奖励配置',
      daysnumber:'天数',
      points:'积分',
      balance:'余额',
      coupons:'优惠券',
      couponsnumber:'优惠券数量',
      continuoussigninreward:'连续签到奖励配置',
  },
  HuiFuAppConfig:{
      appid:'应用ID',
      appconfiguration:'应用配置',
      createtime:'创建时间',
  },
  HuiFuMenberConfig:{
      address:"地址",
      addperson:'新增个人',
      addEnterprise:'新增企业',
      userID:'用户ID',
      payaccountId:'结算账户ID',
      payaccountoperation:'结算账户操作',
      binding:'绑定',
      unbind:'解绑',
      HuiFuuser:'汇付用户',
      Address:'地址',
      gender:'性别',
      Provincecode:'省份编码',
      RegionCode:'地区编码',
      socialCreditCode:'社会信用代码',
      socialCreditCodeExpires:'营业执照过期时间',
      legalPerson:'法人',
      legalCertId:'法人身份证号',
      legalCertIdExpires:'身份证过期时间',
      legalMP:'法人手机号',
      businessScope:'经营范围',
      settleaccountconfig:'结算账户配置',
      bankaccounttype:'银行账户类型',
      forpublic:'对公',
      forPrivate:'对私',
      bankcardid:'银行卡号',
      bankcardname:'银行户名',
      telNumber:'手机号',
      certId:'身份证号',
      certtype:'证件类型',
      identitycard:'身份证',
    bankcodepublic:'银行编码(对公必填)',
    provcodepublic:'省份编码(对公必填)',
    areacodepublic:'地区编码(对公必填)',
  },
  HuiFuPaymentConfig:{
    belongingusers:'所属用户',
    configoperations:'配置操作',
    bindapp:'绑定应用',
    bindledger:'绑定分账用户',
    bindsettlement:'绑定结算账户',
    settlementuser:'结算用户',
    proportion:'比例',
    bindappid:'绑定appId',
    EquipId:'机器编号',
  },
  rechargeStrategy:{
    couponstrategy:'优惠券策略',
    deductionamount:'抵扣金额',
    rechargename:'充值名称',
    paidamountyuan:'实付金额(元)',
    discountamountyuan:'优惠金额(元)',
    couponsnumber:'优惠券张数',
  },
  miniuser:{
    Authorizedpn:'授权过手机号',
    profilepicture:'头像',
    focustime:'关注时间',
    availablecoupons:'可用优惠券',
    remainingcoupons:'剩余优惠券',
    coupontype:'券种',
    issuedate:'发放日期',
  },
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js